import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { AddIcon } from "../../../../public/assets";
import { useNavigate } from "react-router-dom";
import AddNewProductModal from "../../../components/AddNewProduct/AddNewProduct.Component";
import CharityProductModal from "../CharityAddModal/CharityAddProdict";
import { LoadingSpinner } from "../../AddUserPage/AddUser";

interface SelectPopProps {
  onClick: () => void;
  isEdit?: string;
  pageType:
    | "products"
    | "charity/donation"
    | "Adhoc"
    | "donation"
    | "charity"
    | "adhoc";
  id?: string;
  loading?: boolean;
}

const SelectPopMain = styled.div`
  box-shadow: -3px 5px 15px 0px #b0b0b040;
  width: 81%;
`;
const SelectPopContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0px 10px 30px;
  background: #ffffff;
  border: 1px solid #e8eaed;
  height: 35px;
  cursor: default;
  border-radius: 10px;
`;
const SelectPopSpan = styled.span`
  font-size: 14px;
  font-weight: 400;
  cursor: default;
`;

const SelectPop: React.FC<SelectPopProps> = ({
  onClick,
  pageType,
  id,
  loading,
}) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    console.log("Click event triggered!");
    if (
      modalRef.current &&
      !modalRef?.current?.contains(event.target as Node)
    ) {
      setModalOpen(false);
    }
  };

  useEffect(() => {
    const eventListener = document.addEventListener(
      "mousedown",
      handleClickOutside
    );
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  let buttonText: string;
  let modalComponent: React.ReactNode;
  switch (pageType) {
    case "products":
      buttonText = "Add new product";
      modalComponent = <AddNewProductModal onClose={closeModal} />;
      break;
    case "charity/donation":
    case "donation":
    case "charity":
      buttonText = "Add new charity/donation";
      modalComponent = <CharityProductModal onClose={closeModal} />;
      break;
    case "Adhoc":
    case "adhoc":
      buttonText = "Add new another type";
      modalComponent = null;
      break;
    default:
      buttonText = "Add new";
      modalComponent = null;
  }

  return (
    <>
      <SelectPopMain id={id}>
        <SelectPopContent onClick={openModal}>
          <img
            src="/assets/svg/AddIcon.svg"
            style={{ width: "15px", height: "auto", paddingRight: "10px" }}
          />
          <SelectPopSpan>
            {loading ? <LoadingSpinner small /> : buttonText}
          </SelectPopSpan>
        </SelectPopContent>
      </SelectPopMain>
      {modalOpen && <div ref={modalRef}>{modalComponent}</div>}
    </>
  );
};
interface ProductDropdownListItemsProps {
  img?: string;
  text: any;
  onClick: () => any;
}
export const ProductDropdownListItems = ({
  img,
  text,
  onClick,
}: ProductDropdownListItemsProps) => {
  return (
    <SelectPopMain data-testid={text}>
      <SelectPopContent onClick={onClick}>
        {img && (
          <img
            src={img}
            style={{ width: "15px", height: "auto", paddingRight: "10px" }}
          />
        )}
        <SelectPopSpan>{text}</SelectPopSpan>
      </SelectPopContent>
    </SelectPopMain>
  );
};

export default SelectPop;
